/**
 * G5 / G5.1 / G5.2 — helpers UI réellement utilisés par le panneau et la carte admin.
 */

/** Paire complète utilisable (miroir UI des invariants G5). */
export function isCompleteCoordPair(lat, lng) {
  if (lat === '' || lng === '' || lat == null || lng == null) return false;
  const a = Number(lat);
  const b = Number(lng);
  if (!Number.isFinite(a) || !Number.isFinite(b)) return false;
  if (a < -90 || a > 90 || b < -180 || b > 180) return false;
  if (a === 0 && b === 0) return false;
  return true;
}

export function canShowAdminActions(role) {
  return role === 'ADMIN' || role === 'SUPER_ADMIN';
}

/** Payload overview : jamais de champs GPS (stratégie A G5.1). */
export function stripCoordinateFieldsFromOverviewPayload(editData = {}) {
  const {
    latitude,
    longitude,
    latitudeOverride,
    longitudeOverride,
    ...rest
  } = editData;
  void latitude;
  void longitude;
  void latitudeOverride;
  void longitudeOverride;
  return rest;
}

/**
 * G5.2 — Payload pour PUT /coordinates/override (carte admin, stratégie A).
 * Aucun champ de confiance / validation / fingerprint.
 * @returns {{ latitude: number, longitude: number } | null}
 */
export function buildMapOverridePayload(lat, lng) {
  if (!isCompleteCoordPair(lat, lng)) return null;
  return { latitude: Number(lat), longitude: Number(lng) };
}
